import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import { appConfig } from "@shared/utils/appConfig";
import { setBrandOverrideCookieForStaging } from "@shared/utils/brand-override-cookie";

setBrandOverrideCookieForStaging();

async function prepare() {
  if (appConfig.SIDEKICK_MSW_ENABLED && appConfig.NODE_ENV !== "production") {
    const { worker } = await import("@shared/mocks/browser");
    return worker.start({ onUnhandledRequest: "bypass" });
  }
}

const rootElement = document.getElementById("root")!;

function render() {
  if (appConfig.NODE_ENV === "production") {
    ReactDOM.createRoot(rootElement).render(<App />);
  } else {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  }
}

prepare()
  .then(render)
  .catch((error) => {
    console.warn(
      "[MSW] Failed to start service worker, continuing without it:",
      error,
    );
    render();
  });
